export default function hasDimensions(obj) {
    return (parseInt(obj.height, 10) > 0 && parseInt(obj.width, 10) > 0);
}


// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/dom/hasDimensions.js